var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resGray lighten-6"},[(_vm.poolsActive)?_c('pools-cycles',{on:{"openCyclePage":_vm.openCyclePage}}):_vm._e(),(_vm.cyclesActive)?_c('add-cycles',{attrs:{"poolInfo":_vm.poolInfo},on:{"refreshCyclePage":_vm.openCyclePage,"openPoolsPage":_vm.openPoolsPage}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }